import { ChevronDown } from 'lucide-react';
import { type ReactNode, useState } from 'react';

import { cn } from '../../lib/utils';

interface CollapsiblePanelProps {
  children: ReactNode;
  className?: string;
  defaultExpanded?: boolean;
  description?: string;
  title: string;
  toolbar?: ReactNode;
}

export function CollapsiblePanel({
  children,
  className,
  defaultExpanded = false,
  description,
  title,
  toolbar,
}: CollapsiblePanelProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const contentId = `panel-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;

  return (
    <section
      className={cn('overflow-hidden rounded-lg border border-border bg-surface', className)}
    >
      <div className="flex min-h-14 items-center gap-3 px-4">
        <button
          type="button"
          className="flex min-w-0 flex-1 items-center gap-3 py-3 text-left"
          aria-controls={contentId}
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
        >
          <ChevronDown
            className={cn('h-4 w-4 shrink-0 text-text-muted transition', !expanded && '-rotate-90')}
            aria-hidden="true"
          />
          <span className="min-w-0">
            <span className="block font-semibold">{title}</span>
            {description ? (
              <span className="block truncate text-xs text-text-muted">{description}</span>
            ) : null}
          </span>
        </button>
        {toolbar ? <div className="shrink-0">{toolbar}</div> : null}
      </div>
      {expanded ? (
        <div id={contentId} className="border-t border-border px-4 py-3">
          {children}
        </div>
      ) : null}
    </section>
  );
}
